import React, {createContext, useContext, useState} from "react"

export const Context = createContext();

export const useMobileNavContext = () => {
    return useContext(Context);
}

export const MobileNavContext = ({ children }) => {
    const [isMobileOpen, setIsMobileOpen] = useState(false);

    return (
        <Context.Provider
            value={[isMobileOpen, setIsMobileOpen]}
        >
            {children}
        </Context.Provider>
    )
}